import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './util/http'
import store from './store'
import './styles/index.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'

import './styles/common.scss'
import basicContainer from './components/basic-container/main'
import website from '@/config/website'
import { aliOss } from '@/config'

window.axios = axios

Vue.use(Avue, {
  ali: aliOss
})

Vue.use(ElementUI, { size: 'small' })

// 注册全局容器
Vue.component('basicContainer', basicContainer)
Vue.config.productionTip = false

// 加载website
Vue.prototype.website = website

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
